import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const FLOW = 'flow'
export const GROUP_FLOW = 'group flow'
export const NEXT_QUESTION = 'next question'
export const NEXT = 'next'
export const SCREENED = 'Screened'
export const FINISH = 'finish'
export const IF_YOU_ANSWER = 'if you answer'
export const AND = 'and'
export const OR = 'or'
export const GO_TO = 'go to'
export const NO_CONDITION = 'no condition'
export const ADD_CONDITION = 'add condition'

export default {
  [PORTUGUESE]: {
    [FLOW]: 'Fluxo',
    [GROUP_FLOW]: 'Fluxo de Grupo',
    [NEXT_QUESTION]: 'Próxima Questão',
    [NEXT]: 'Próxima',
    [SCREENED]: 'Screened',
    [FINISH]: 'Terminar',
    [IF_YOU_ANSWER]: 'Se você responder',
    [AND]: 'e',
    [OR]: 'ou',
    [GO_TO]: 'vai para',
    [NO_CONDITION]: 'Sem condição',
    [ADD_CONDITION]: 'Adicionar Condição',
  },

  [ENGLISH]: {
    [FLOW]: 'Flow',
    [GROUP_FLOW]: 'Group Flow',
    [NEXT_QUESTION]: 'Next Question',
    [NEXT]: 'Next',
    [SCREENED]: 'Screened',
    [FINISH]: 'Finish',
    [IF_YOU_ANSWER]: 'If you answer',
    [AND]: 'and',
    [OR]: 'or',
    [GO_TO]: 'go to',
    [NO_CONDITION]: 'No condition',
    [ADD_CONDITION]: 'Add Condition',
  },

  [SPANISH]: {
    [FLOW]: 'Flujo',
    [GROUP_FLOW]: 'Flujo de Grupo',
    [NEXT_QUESTION]: 'Próxima Pregunta',
    [NEXT]: 'Próxima',
    [SCREENED]: 'Screened',
    [FINISH]: 'Finalizar',
    [IF_YOU_ANSWER]: 'si respondes',
    [AND]: 'y',
    [OR]: 'o',
    [GO_TO]: 'ir',
    [NO_CONDITION]: 'Sin condicion',
    [ADD_CONDITION]: 'Añadir Condición',
  },
}
